type LocaleBadgeProps = {
	children?: React.ReactNode
}

export const LocaleBadge = ({ children }: LocaleBadgeProps) => <div className="locale-badge">{children}</div>
